import { request } from "@/plugins/axios";

export async function getSystemImage  (type) {
    try{
        const url = `/portal/systemConfig/imageUrl/${type}`;
        const {code,data} = await request.get(url);
        if(code == 200){
            return data.url;
        }
    }
    catch(e){
        console.error('获取系统图片出错',e);
    }
}

export  function getSpecList() {
    return request.get('/portal/image/list?state=5')
}

export function getSpecDetail(id){
    return request.get(`/portal/image/${id}`);
}